import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const salesOrderLineItemsListAtom = createQueryAtomFactory(
  'trade.salesOrdersWithLineItems',
  (params: { salesOrderId: string }) => ({
    salesOrders: {
      __args: {
        filter: {
          includeLineItems: true,
          ids: [params.salesOrderId],
        },
        pagination: {
          limit: 1,
          offset: 0,
        },
      },
      entries: {
        id: true,
        account: {
          id: true,
          name: true,
        },
        lineItems: {
          id: true,
          item: {
            id: true,
            name: true,
          },
          unit: true,
          unitPrice: {
            amount: true,
            currencyCode: true,
          },
          totalPrice: {
            amount: true,
            currencyCode: true,
          },
          quantity: true,
        },
      },
    },
  }),
);
